export default __webpack_public_path__ + "static/media/down-button.014e890d.svg";